import { ref } from 'vue'

/**
 * Safe backdrop dismiss for modal overlays.
 * Only closes when pointer down AND up both occur on the backdrop —
 * prevents accidental close when dragging a text selection outside the dialog.
 */
export function useBackdropDismiss() {
  const pointerDownOnBackdrop = ref(false)

  function onBackdropPointerDown(event) {
    pointerDownOnBackdrop.value = event.target === event.currentTarget
  }

  function onBackdropClick(event, onDismiss) {
    if (pointerDownOnBackdrop.value && event.target === event.currentTarget) {
      onDismiss()
    }
    pointerDownOnBackdrop.value = false
  }

  return { onBackdropPointerDown, onBackdropClick }
}
